import { isAxiosApiProblemWithDetail } from "@vyne-shared/api/errors";
import { isMissingLegalInfoError, missingLegalInfoModal } from "api/exceptions";
import type { HookAPI } from "antd/es/modal/useModal";

/** Display an error if data submission fails. */
export function displaySubmissionError(antdModal: HookAPI, error: Error) {
    const cause = error.cause ?? error;

    return (
        tryDisplayMissingLegalInfo(antdModal, cause) ||
        tryDisplayGenericDetail(antdModal, cause) ||
        displayGenericFallback(antdModal)
    );
}

function tryDisplayMissingLegalInfo(antdModal: HookAPI, error: unknown) {
    if (isMissingLegalInfoError(error)) {
        antdModal.error(missingLegalInfoModal);
        return true;
    }
    return false;
}

function tryDisplayGenericDetail(antdModal: HookAPI, error: unknown) {
    if (isAxiosApiProblemWithDetail(error)) {
        antdModal.error({
            title: "Unable to submit Bulk Request",
            content: error.response.data.detail,
        });
        return true;
    }
    return false;
}

function displayGenericFallback(antdModal: HookAPI) {
    antdModal.error({
        title: "Unable to submit Bulk Request",
        content: "Please review the payment data you have entered. Contact support if this error persists.",
    });
}
